import { useRole } from 'features/auth/contexts/RoleContext';
import { Capability } from 'core/roles';

/**
 * Gate d'UI par capacité, piloté par la SESSION (double mode : rôle actif legacy
 * ou portail + briques) :
 *   const canOpen = useRoleCan(Capability.SimulationOpen);
 *
 * S'appuie sur la matrice centrale (core/roles), PAS sur les
 * permissions ABP (non fiables pour le multi-rôles). Un seul endroit pour changer un droit.
 */
export const useRoleCan = (capability: Capability): boolean => {
  const { can } = useRole();
  return can(capability);
};
